import Swal from "sweetalert2";

/**
 * Objeto de mixin de SweetAlert2
 *
 * @typedef {Object} SwalMixin
 * @property {Object} customClass - El objeto que especifica las clases CSS para el elemento popup
 * @property {string} customClass.popup - La clase CSS para el elemento popup
 */

/**
 * Una instancia de SweetAlert2 con clases CSS personalizadas para el elemento popup.
 *
 * @type {SwalMixin}
 */
export const swal = Swal.mixin({
  customClass: { popup: 'max-h-50-screen overflow-auto' }
});

export const swalRendimiento = Swal.mixin({
  customClass: {
    popup: 'max-w-[400px] w-full p-6 rounded-lg shadow-lg'
  }
});


/**
 * Un array con los nombres de los meses.
 *
 * @type {string[]}
 */
export const monthNames = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre"
];